import React, { useState,useEffect } from 'react';
import { Button, Checkbox, InfoBox, Input } from 'components';
import { Modal, Form } from 'antd';
import '../basket-summary.less'
import 'components/Modal/modal.less'


const PaycellModal = (props) => {
  const [modal, showModal] = useState(false);
  const [showCardName, isShowCardName] = useState(false);



  return (
      <React.Fragment>
          <Form.Item  name="saveCC">
                                  <Checkbox onClick={(e)=> {(e.target.checked ? isShowCardName(true): isShowCardName(false))}}
                                    text={
                                      <>
                                        Kartımı PayCell’e kaydet. Kartınızı
                                        kaydetmeniz durumunda{' '}
                                        <a onClick={ () => showModal(true) }>
                                          Kart Saklama Sözleşmesi
                                        </a>
                                        ’ni kabul etmiş olacaksınız.
                                      </>
                                    }
                                  />
           
          </Form.Item>
          {showCardName &&         
          <Form.Item  name="cardName">
          <Input
                                    type="text"
                                    label="Kart adı"
                                    name="cardName" maxLength={20}
                                  />
           
          </Form.Item> }
          <Modal width={600}
            title="Paycell Kart Saklama"
            visible={ modal }
            onCancel={ () => showModal(false) }
            footer={[
              <div className="modal-action">
                <Button
                  shape="round"
                  type="ghost"
                  onClick={ () => showModal(false) }
                >
                  Kapat
                </Button>
              </div>
            ]}>
          <InfoBox content={ <div>  <p align='center'>
    <strong>Kart Saklama Hizmetleri Kullanıcı Sözleşmesi</strong>
</p>
<p align='center'>
    <strong> </strong>
</p>
<p>
    <strong>1. </strong>
    <strong>Sözleşme’nin Tarafları</strong>
</p>
<p>
    İşbu Kart Saklama Hizmetleri Kullanıcı Sözleşmesi (“Sözleşme”), Aydınevler
    Mahallesi İnönü Caddesi No:20 Küçükyalı Ofispark B Blok - Maltepe /
    İSTANBUL adresinde faaliyet göstermekte olan Turktell Bilişim Hizmetleri
    A.Ş. (“Turktell”) ile işbu Sözleşme’yi onaylanan kişi (“Kullanıcı”)
    arasında akdedilmiştir.
</p>
<p>
    <strong>2. </strong>
    <strong>Sözleşme’nin Konusu </strong>
</p>
<p>
    İşbu Sözleşme kapsamında Turktell, Kullanıcı’nın kredi kartı bilgilerini
    kaydetmesine ve Turktell anlaşmalı kurumları (“Üye İşyeri”) nezdinde
    yapacağı ödemelerde kayıtlı kredi kartlarını kullanmasına yönelik
    hizmetleri (“Hizmet”) sunacak olup, Sözleşme, tarafların bu kapsamdaki hak
    ve yükümlülüklerini ortaya koymak amacıyla akdedilmektedir.
</p>
<p>
    İşbu Sözleşme kapsamında Turktell tarafından ödeme hizmeti sunulması,
    herhangi bir ödemeye aracılık edilmesi söz konusu değildir.
</p>
<p>
    <strong>3. </strong>
    <strong>Hizmet’e ilişkin Usul ve Esaslar </strong>
</p>
<p>
    3.1 Kullanıcı, işbu Sözleşme kapsamında, Üye İşyerleri nezdinde
    gerçekleştireceği işlemler özelindeki onayı dahilinde ödeme işlemlerinin
    kolaylaştırılması amacı ile kullanılmak üzere kredi kartı bilgilerini
    Turktell ile kendi rızası ile paylaşmaktadır. Paylaşılan bu bilgiler; kredi
    kartının bağlı olduğu banka, kredi kartının ön yüzünde yer alan ad soyad,
    kart numarası, son kullanım tarihi ile sınırlıdır.
</p>
<p>
    3.2 Kullanıcı, Sözleşme kapsamında sağlanan bilgilerin kendisine ait
    olduğunu, doğru ve gerçek olduğunu, söz konusu kredi kartı ile yapılan tüm
    işlemlerden tek başına sorumlu olduğunu, bu işlemlere ilişkin olarak her
    türlü hukuki ve cezai sorumluluğun kendisine ait olduğunu kabul ve taahhüt
    eder.
</p>
<p>
    3.3 Kullanıcı kart numarası, son kullanma tarihi ve güvenlik kodu
    bilgilerini sisteme girerek yapacağı ilk geçerli ödeme işlemi ile sisteme
    kayıt olur. Başarılı bir şekilde kart ekleyen Kullanıcı, daha sonraki
    kullanımlarda bir daha ek bir bilgi girmeyi gerektirmeden kartını
    kullanacaktır. Bu kapsamda; Kullanıcı kendi inisiyatifi doğrultusunda
    Turktell’in belirlediği limitler dahilinde istediği adette kredi kartını
    sisteme ekleyebilir. Kullanıcı, tüm bu kredi kartları ve bunların kullanımı
    ile gerçekleştirilen işlemlere ilişkin olarak işbu Sözleşme’nin geçerli
    olduğunu kabul eder.
</p>
<p>
    3.4 Kullanıcı kredi kartı ile ödeme kanallarından birisinde işlem yapmak
    istediğinde, kendisine kayıtlı kredi kart(lar)ını ayırt edebileceği
    bilgiler (kart rumuzu, kartın son 4 hanesi vb) listelenerek, bu kart(lar)ı
    ile işlem yapmak isteyip istemediği sorulacak, isteyen kullanıcıların
    vereceği işlem onayı ile birlikte kullanıcının onayı ile sona erecektir.
    Turktell ileride işlem akışında değişik yapabilir, kullanıcının güvenliği
    için ek önlemler (şifre vb.) getirebilir. Kullanıcı, bu sistem dahilinde
    belirleyeceği ve kullanacağı tüm şifrelerin güvenliğinden ve gizliliğinden
    tek başına sorumlu olduğunu, şifrelerini üçüncü kişilerle paylaşmamayı,
    sisteme tanımladığı kredi kartı ile yapılan tüm işlemlerden tek başına
    sorumlu olduğunu kabul ve taahhüt eder.
</p>
<p>
    3.5 Kullanıcı Turkcell Grup Şirketleri’ne ve iş ortaklarına ait kanallardan
    kaydettiği kartını kaybetmesi veya çaldırması durumunda bankası ile
    iletişime geçmek ve çalınan kartın kapatılmasını sağlamaktan kendisi
    sorumludur.
</p>
<p>
    3.6 Kullanıcı, Turkcell abonesi olmadığı takdirde, hattın iptal
    ettirilmesi, devredilmesi ve kullanıma kapatılması koşullarında kayıtlı
    kartlarının Turktell’den kaldırılmasından kullanıcı sorumludur. Bu
    durumlarda kart(lar)ın kaldırılmamasından ve gerçekleşebilecek işlemlerden
    kullanıcı sorumludur.
</p>
<p>
    3.7 Kullanıcı, Hizmet’in kullanımı sırasında işbu sözleşme ve yürürlükteki
    mevzuata uygun hareket etmekle yükümlüdür. Turktell tarafında herhangi bir
    aykırılık şüphesi söz konusu olduğu takdirde, Hizmet’i askıya alabilecek
    veya işbu sözleşmeyi feshederek sonlandırabilecektir. Kullanıcı, işbu
    sözleşme veya mevzuata aykırılığı neticesinde Turkcell Grup Şirketleri
    nezdinde meydana gelen tüm zararları tazmin edecektir.
</p>
<p>
    3.8 Turktell, işbu Sözleşme kapsamındaki hak ve yükümlülüklerini,
    Kullanıcı’ya bildirim yükümlülüğü olmaksızın Grup Şirketlerinden herhangi
    birine devredebilecektir. Kullanıcı bu kapsamda işbu Sözleşme uyarınca
    Turktell’e sunmuş olduğu ve/veya Turkcell Grup Şirketleri tarafından işbu
    Sözleşme çerçevesinde toplanmış, oluşturulmuş bilgi ve verilerin, Hizmet’in
    sunulması amacı ile Turkcell Grup Şirketine devredilebileceğini kabul ile
    söz konusu devre peşinen muvafakat ettiğini beyan eder. Turktell,
    yürürlükteki mevzuata uyumu sağlamak adına herhangi bir zamanda
    Kullanıcı’dan ek bilgi, belge veya onay talep edebilecek olup, Kullanıcı bu
    talepleri yerine getireceğini kabul eder.
</p>
<p>
    3.9 Sözleşme konusu Hizmet Turktell tarafından ücretsiz olarak
    sunulabileceği gibi, zaman zaman çeşitli kampanyalara konu edilebilecek
    veya ücrete tabi bir şekilde sunulabilecektir. Kullanıcı, Hizmet’i
    kullandığı müddetçe Turktell’in ücretlendirme politikası ile bağlı olduğunu
    kabul eder.
</p>
<p>
    <strong>4. </strong>
    <strong>Kişisel Verilerin İşlenmesine ilişkin Esaslar</strong>
</p>
<p>
    4.1 Kullanıcı, bu Sözleşme’yi onaylamasıyla işbu Sözleşme süresince ve her
    halukarda hukuken işlemeye ilişkin meşru nedenler ortadan kalkıncaya kadar
    Sözleşme kapsamında ürün ve hizmetlerin sunulabilmesi, özel ürün ve
    hizmetlerin önerilebilmesi, bu kapsamda Paycell markası altında hizmet ve
    ürünün sağlanması, geliştirilmesi dahil gerekli çalışmaların yapılması,
    Şirket tarafından ticari kararların verilmesi, uygulanması ve
    gerçekleştirilmesi, gerekli adımların atılması, Şirket’in bu ilişkilerden
    kaynaklı hukuki emniyetinin sağlanması, ödemelerin gerçekleştirilmesi,
    mevzuat kapsamındaki yükümlülüklerin yerine getirilmesi, vermeyi
    hedeflediği en iyi hizmetin temini amacı ile cep telefonu aboneliği
    hatlarına ait telefon numarası, TCKN, adres bilgisi, konum bilgisi, ad,
    soyad, kart numarası, kartına vermek istediği isim, son kullanım tarihi vb
    gereken kişisel bilgilerin (Kişisel Bilgi) Şirket tarafından işlenmesine,
    yasal düzenlemelerin imkân verdiği ölçüde; anılan amaçlar ve süre ile
    Turkcell Grup Şirketleri, Üye İşyerleri, Sözleşme ifası için hizmet alınan
    şirketler, temsilcileri, acenteleri, çözüm ortakları ile karşılıklı olarak
    paylaşılmasına ve işlenmesine izin vermektedir. Ayrıca ek olarak, Şirket,
    işbu Sözleşme’den doğabilecek herhangi bir uyuşmazlık durumunda, uyuşmazlık
    kapsamında gerekli savunmaların gerçekleştirilebilmesi amacıyla sınırlı
    olmak üzere ve ilgili mevzuat uyarınca belirlenen zamanaşımı süreleri
    boyunca kişisel verileri saklayacaktır.
</p>
<p>
    4.2 Kullanıcı her zaman için Çağrı Merkezi vb. Turkcell Grup Şirketlerince
    yönetilen kanallardan bilgilerinin kaydedilmesine ilişkin verdiği izni geri
    alabileceğini ve kayıtlı bilgileri silebileceğini kabul eder. Ancak
    Kullanıcı, bu durumda paylaştığı bilgilere istinaden sunulmakta olan
    servislerden yararlanamayacağını kabul eder. Buna ek olarak, Kullanıcı,
    Kişisel Verilerin Korunması Kanunu’nun 11. maddesinin yürürlüğe girmesi ve
    işbu Sözleşme kapsamında uygulanması gerekmesi ile birlikte Turktell’e
    başvurarak kendisiyle ilgili;
</p>
<p>
    • Kişisel veri işlenip işlenmediğini öğrenme,
</p>
<p>
    • Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,
</p>
<p>
    • Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp
    kullanılmadığını öğrenme,
</p>
<p>
    • Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü
    kişileri bilme,
</p>
<p>
    • Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların
    düzeltilmesini isteme,
</p>
<p>
    • İlgili mevzuatta öngörülen şartlar çerçevesinde kişisel verilerin
    silinmesini veya yok edilmesini isteme,
</p>
<p>
    • İlgili mevzuat uyarınca yapılan düzeltme, silme ve yok edilme
    işlemlerinin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini
    isteme,
</p>
<p>
    • İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz
    edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına
    itiraz etme,
</p>
<p>
    • Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara
    uğraması halinde zararın giderilmesini talep etme,
</p>
<p>
    haklarına sahip olacaktır. Söz konusu haklar, yukarıda belirtilen
    kanalların yanı sıra Aydınevler Mahallesi İnönü Caddesi No:20 Küçükyalı
    Ofispark B Blok - Maltepe / İSTANBUL adresine yazılı talep iletilerek
    kullanılabilecektir.
</p>
<p>
    4.3 Turktell, yukarıda yer alan talepler uyarınca, gerekçeli olumlu/olumsuz
    yanıtını, yazılı veya dijital ortamdan gerçekleştirebilir. Taleplere
    ilişkin gerekli işlemler için ücret alınmaması esastır. Bununla birlikte,
    işlemlerin bir maliyet gerektirmesi halinde, Kişisel Verilerin Korunması
    Kurulu tarafından, Kişisel Verilerin Korunması Kanunu’nun 13. maddesine
    göre belirlenen tarife üzerinden ücret talep edilmesi mümkündür.
</p>
<p>
    4.4 Kullanıcı, veri işleme iznini her zaman Turkcell Grup Çağrı Merkezleri
    aracılığıyla iptal edebilir. Veri işleme izninin iptali, bu sözleşme
    uyarınca paylaştığı bilgilerin işlenmesi ve paylaşılmasına engel teşkil
    etmez (bu konuda 4.1 ve 4.2. madde hükümleri geçerlidir) ancak Kullanıcı
    veri işleme iznini iptal etmesi durumunda Turktell’in sözleşme konusu
    Hizmet’i tam ve gereği gibi sunamayabileceğini kabul eder.
</p>
<p>
    4.5 Turktell, ilgili mevzuatta belirlenen veya işbu sözleşmede ifade edilen
    şartlarda, işbu sözleşme kapsamında kendisine elektronik ortamda iletilen,
</p>
<p>
    • kişisel verilerin hukuka aykırı olarak işlenmesini,
</p>
<p>
    • kişisel verilere hukuka aykırı olarak erişilmesini, ve
</p>
<p>
    • kişisel verilerin muhafazasını sağlamak amacıyla uygun güvenlik düzeyini
    temin etmeye yönelik gerekli her türlü teknik ve idari tedbirleri almayı,
    gerekli denetimleri yaptırmayı
</p>
<p>
    taahhüt eder.
</p>
<p>
    4.6 Turktell, bahsi geçen kişisel verileri bu işbu sözleşme ve Kişisel
    Verilerin Korunması Kanunu hükümlerine aykırı olarak başkasına açıklayamaz
    ve işleme amacı dışında kullanamaz. Turktell, işbu sözleşme hükümleri
    uyarınca dışkaynak hizmet sağlayıcılarla Kullanıcılar’a ait kişisel
    verilerin paylaşılması durumunda, söz konusu dışkaynak tedarikçilerinin de
    işbu madde altında yer alan taahhütlere riayet edeceğini beyan eder.
</p>
<p>
    <strong>5. </strong>
    <strong>Hizmet ve Sözleşme’nin Yürürlüğü ve Sona Ermesi </strong>
</p>
<p>
    5.1 İşbu Sözleşme konusu Hizmet’in kapsamı ve devamı Turktell’in
    inisiyatifindedir. Turktell, her zaman Hizmet’i sunmayı kısmen veya
    tamamen, süreli veya süresiz olarak, Kullanıcı’ya herhangi bir bildirim
    yapma yükümlülüğü olmaksızın durdurabilir. Kullanıcı uygulama üzerinde
    yapılacak iyileştirme ve diğer değişiklikleri uygulamak için Hizmet ve
    uygulamaya erişimin geçici olarak engellenebileceğini kabul eder.
</p>
<p>
    5.2 İşbu Sözleşme Turktell ya da kullanıcı tarafından mevzuata uygun olarak
    feshedilmediği müddetçe yürürlükte kalır.
</p>
<p>
    <strong>6. </strong>
    <strong>Sorumlulukların Sınırlandırılması</strong>
</p>
<p>
    6.1 Turktell’in işbu Sözleşme kapsamındaki sorumluluğu Hizmet’in sunulması
    ile sınırlı olup, işbu sözleşmede yer alan hiçbir hüküm Turktell’in Hizmet
    kapsamında saklanmakta olan kredi kartı ile yapılan işlemlere ilişkin
    herhangi bir sorumluluğu bulunduğu şeklinde yorumlanmayacaktır. Söz konusu
    işleme ve işlem sonucunda temin edilen mal ve/veya hizmete ilişkin tüm
    sorumluluk satış işleminin tarafı olan kişi veya kuruma aittir. Kullanıcı,
    bu kapsamdaki her türlü talep ve şikayetini doğrudan ilgili kişi ve kuruma
    iletmesi gerektiğini bilmekte ve kabul etmektedir.
</p>
<p>
    6.2 Kullanıcı tarafından sağlanan kart bilgilerinin tam, doğru ve güncel
    olmaması, kredi kartının geçersiz veya kullanılamaz olması gibi
    Turktell’den kaynaklanmayan nedenlerle işlem yapılamamasından dolayı
    Turktell’in herhangi bir sorumluluğu olmayacaktır. Hizmet kapsamında
    saklanan kredi kartlarının güncel ve geçerli olmasından ve tam, doğru ve
    güncel bilgiler sağlanmasından münhasıran Kullanıcı sorumludur.
</p>
<p>
    6.3 Hizmetler “OLDUĞU GİBİ” sunulmakta olup, bu kapsamda Turktell’in
    Hizmet’in Kullanıcı’nın şahsi beklentilerini karşılayacağı veya belirli bir
    amaca uygunluğu ile ilgili herhangi bir taahhüdü bulunmamaktadır. Turkcell
    Grup Şirketleri, kar kaybı, şerefiye ve itibar kaybı, ikame ürün ve hizmet
    temini için yapılan harcama vs. de dahil ancak bununla sınırlı olmaksızın
    Hizmet’in kullanımı neticesinde meydana gelen hiç bir dolaylı, özel, arızi,
    cezai zarardan sorumlu olmayacaktır.
</p>
<p>
    <strong>7. </strong>
    <strong>Muhtelif Hükümler</strong>
</p>
<p>
    7.1 İşbu Sözleşme’den doğabilecek ihtilaflarda Turkcell Grup Şirketleri’nin
    veritabanında, sunucularında tuttuğu elektronik ve sistem kayıtlarının,
    ticari kayıtlarının, defter ve diğer kayıtlarının, mikrofilm, mikrofiş ve
    bilgisayar kayıtları muteber bağlayıcı, kesin ve münhasır delil teşkil
    edecek olup bu madde HMK 193. Madde anlamında kesin delil sözleşmesi
    niteliğindedir.
</p>
<p>
    7.2 Eğer işbu Sözleşme’nin herhangi bir hükmü, herhangi bir sebepten ötürü
    geçersiz, mevzuata aykırı veya uygulanamaz hale gelirse, bu geçersizlik,
    uygulanamama veya mevzuata aykırılık hali olmasaydı nasıl uygulanacak
    idiyse, buna en yakın şekilde yorumlanır ve uygulanır. Böyle geçersiz,
    uygulanamaz veya mevzuata aykırı olarak kabul edilen bir hükmün mevcudiyeti
    diğer hükümlerin geçerliliği, yasalara uygunluğu ve uygulanabilirliğini
    etkilemez.
</p>
<p>
    7.3 İşbu Sözleşme’nin uygulanmasında, yorumlanmasında, işbu Sözleşme
    dâhilinde doğan hukuki ilişkilerin yönetiminde yabancılık unsuru bulunması
    durumu da dâhil olmak üzere, Türk Hukuku uygulanacağını, sözleşmeden doğan
    veya doğabilecek her türlü ihtilafın hallinde İstanbul Çağlayan Mahkemeleri
    ve İcra Dairelerinin yetkili olacaktır.
</p>
<p>
    7.4 Turktell, işbu Sözleşme’yi dilediği zamanda güncelleyebilecek olup,
    yürürlükte bulunan mevzuat kapsamında aksi bir zorunluluk söz konusu
    olmadığı sürece Turktell tarafından yapılan değişiklikler, değişiklik
    tarihi itibariyle yürürlüğe girecektir.
</p>
<p>
    Kullanıcı yukarıda düzenlenen hususları okuyup anladığını, işbu kabul
    beyanının gerçek iradesini yansıttığını kabul, beyan ve taahhüt eder.
    Kullanıcı’nın elektronik olarak onay vermesi ile bu Sözleşme yürürlüğe
    girecektir.
</p>  </div>} />
          </Modal>
     </React.Fragment>
  )
}

export default PaycellModal